import { GetStaticProps, GetStaticPaths } from 'next';
import { getLanguagesPaths } from '~/utils/translate';
import { NextSeo } from 'next-seo';
import { useTranslate } from '~/i18n';
import TopSection from '~/components/business/inner-pages/top-section';
import Header from '~/components/business/inner-pages/header';
// import BusinessForm from '~/components/business/inner-pages/business-form';

const CorporateWellness = () => {
   const { translate } = useTranslate();
   return (
      <div>
         <NextSeo title={translate({ id: 'innerbusiness:corporate wellness program' })} />

         <Header
            backgroundColor="corporate-entertainment-events-bg"
            smallBackgroundIamge="/images/business/corporate-wellness-program.png"
            title={translate({ id: 'innerbusiness:corporate wellness program' })}
            backgroundImage="/images/business/inner/6.jpg"
            backgroundImageAr="/images/business/inner/6-ar.jpg"
            breadCrumbcolor="text-primary-color"
            titleColor="text-primary-color"
            lastBreadCrumb="بيئة عمل صحية"
         />

         <TopSection
            firstpargraph={translate({
               id: 'innerbusiness:corporate wellness paragraph 1',
            })}
            secondpargraph={translate({
               id: 'innerbusiness:corporate wellness paragraph 2',
            })}
            thirdpargraph={translate({
               id: 'innerbusiness:corporate wellness paragraph 3',
            })}
            // button={translate({ id: 'innerbusiness:corporate wellness button' })}
            img="/images/business/inner/wellness-program.png"
         />
         {/* <BusinessForm /> */}
      </div>
   );
};
export const getStaticPaths: GetStaticPaths = async () => {
   return {
      paths: getLanguagesPaths(),
      fallback: false,
   };
};

/******************************************************************
 *
 *  THIS PAGE IS USING STATIC SITE GENERATION
 *
 ******************************************************************/

export const getStaticProps: GetStaticProps = async () => {
   return {
      props: {},
   };
};
export default CorporateWellness;
